export const walletConnectMetadata = {
  name: 'Mojito Claimable',
  description: 'My Website description',
  url: 'https://www.getmojito.com/',
  icons: ['https://assets-global.website-files.com/645e63ab36fc91c80f486747/645e63ab36fc91c80f486762_Group%201.svg']
};

export const supportedNetworksData = [
  {
    chainId: 1,
    name: 'Ethereum',
    currency: 'ETH',
    explorerUrl: 'https://etherscan.io',
    rpcUrl: 'https://eth.llamarpc.com'
  },
  {
    chainId: 11155111,
    name: 'Sepolia',
    currency: 'ETH',
    explorerUrl: 'https://sepolia.etherscan.io',
    rpcUrl: 'https://rpc.sepolia.org'
  },
  {
    chainId: 8453,
    name: 'Base',
    currency: 'ETH',
    explorerUrl: 'https://basescan.org',
    rpcUrl: 'https://base.llamarpc.com'
  },
  {
    chainId: 84532,
    name: 'Base Sepolia Testnet',
    currency: 'ETH',
    explorerUrl: 'https://sepolia.basescan.org',
    rpcUrl: 'https://sepolia.base.org'
  }
];

export const DEFAULT_WALLET_DETAILS = {
  address: '',
  balance: {
    native: 0,
    nonNative: 0
  },
  networkDetails: {
    chainID: 11155111,
    id: '',
    isTestnet: false,
    name: ''
  },
  provider: null,
  providerType: '',
  refetchBalance: false
};
